/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';
import { ApplicationView, SubOfficeRestService } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { SubOfficeListItem } from './sub-office-list-item.model';

@Injectable()
export class SubOfficeListBusinessService implements InitViewService {
  constructor(public restService: SubOfficeRestService,
              private gridLayoutService: GridLayoutService,
              private userContext: BuilderUserContext) {
  }

  initView(): any {
    return {
      gridLayout: this.userContext.applicationView === ApplicationView.Master ? this.gridLayoutService.get(
        'subOfficesMasterView') : this.gridLayoutService.get('subOfficesOfficeView'),
    };
  }

  findAllAsDataSource(): SlicedDataSource<SubOfficeListItem> {
    return this.restService.findAllAsDataSource();
  }

  deactivate(office: SubOfficeListItem): Observable<SubOfficeListItem> {
    return this.restService.deactivate(office);
  }

  delete(office: SubOfficeListItem): Observable<SubOfficeListItem> {
    return this.restService.delete(office);
  }
}
